var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(_vm._s(_vm.offer_codecs.join(", ")))])
}
var staticRenderFns = []

export { render, staticRenderFns }